export default "__VITE_ASSET__COVGzNE$__"